module.exports = __webpack_public_path__ + "static/media/Ichikawa1F.2ec52697.png";